import React from "react";
import { SkillsDiv } from "../css/Skills.styled";
import { Fade } from "react-awesome-reveal";
import {
  SiJavascript,
  SiTypescript,
  SiGo,
  SiMysql,
  SiC,
  SiNodedotjs,
  SiNestjs,
  SiExpress,
  SiSequelize,
  SiMongodb,
  SiJest,
  SiReact,
  SiRedux,
  SiHtml5,
  SiCss3,
  SiBootstrap,
  SiMaterialui,
  SiChakraui,
  SiPostgresql,
  SiSnowflake,
  SiAmazonaws,
  SiRedis,
  SiKubernetes,
  SiGrafana,
  SiDocker,
  SiNginx,
  SiGithubactions,
  SiTerraform,
  SiGit,
  SiGithub,
  SiSap,
  SiMicrosoftexcel,
  SiMicrosoftpowerpoint,
  SiMicrosoftword,
  SiCanva,
  SiOpenai,
} from "react-icons/si";
import {
  FaCogs,
  FaChartLine,
  FaCode,
  FaSitemap,
  FaProjectDiagram,
  FaRobot,
  FaSearch,
  FaServer,
  FaDatabase,
  FaBrain,
} from "react-icons/fa";

const skillSections = [
  {
    title: "Languages",
    items: [
      { label: "JavaScript", icon: <SiJavascript color="#f7df1e" /> },
      { label: "TypeScript", icon: <SiTypescript color="#3178c6" /> },
      { label: "Golang", icon: <SiGo color="#00add8" /> },
      { label: "SQL", icon: <SiMysql color="#00758f" /> },
      { label: "C (Familiar)", icon: <SiC color="#a8b9cc" /> },
      { label: "OOP Concepts", icon: <FaCogs color="#f97316" /> },
    ],
  },
  {
    title: "Backend",
    items: [
      { label: "Node.js", icon: <SiNodedotjs color="#6cc24a" /> },
      { label: "Nest.js", icon: <SiNestjs color="#e0234e" /> },
      { label: "Bun.js", icon: <FaServer color="#f97316" /> },
      { label: "Express", icon: <SiExpress color="#ffffff" /> },
      { label: "Sequelize", icon: <SiSequelize color="#52b0e7" /> },
      { label: "TypeORM", icon: <FaDatabase color="#38bdf8" /> },
      { label: "Mongoose", icon: <SiMongodb color="#47a248" /> },
      { label: "Jest", icon: <SiJest color="#c21325" /> },
    ],
  },
  {
    title: "Frontend",
    items: [
      { label: "React", icon: <SiReact color="#61dafb" /> },
      { label: "Redux", icon: <SiRedux color="#764abc" /> },
      { label: "HTML5", icon: <SiHtml5 color="#e34f26" /> },
      { label: "CSS3", icon: <SiCss3 color="#1572b6" /> },
      { label: "Bootstrap", icon: <SiBootstrap color="#7952b3" /> },
      { label: "Material UI", icon: <SiMaterialui color="#0081cb" /> },
      { label: "Chakra UI", icon: <SiChakraui color="#319795" /> },
    ],
  },
  {
    title: "Databases",
    items: [
      { label: "PostgreSQL", icon: <SiPostgresql color="#336791" /> },
      { label: "Snowflake", icon: <SiSnowflake color="#29b5e8" /> },
      { label: "MongoDB", icon: <SiMongodb color="#47a248" /> },
      { label: "Amazon Redshift", icon: <SiAmazonaws color="#ff9900" /> },
      { label: "Redis", icon: <SiRedis color="#dc382d" /> },
    ],
  },
  {
    title: "Cloud & DevOps",
    items: [
      {
        label: "AWS (Lambda, ECS, EC2, Fargate, SQS/SNS, S3, CodeBuild, DynamoDB)",
        icon: <SiAmazonaws color="#ff9900" />,
      },
      { label: "Kubernetes", icon: <SiKubernetes color="#326ce5" /> },
      { label: "ArgoCD & Argo Workflows", icon: <FaProjectDiagram color="#f87171" /> },
      { label: "Grafana & Loki", icon: <SiGrafana color="#f46800" /> },
      { label: "Coralogix", icon: <FaChartLine color="#22d3ee" /> },
      { label: "Docker", icon: <SiDocker color="#2496ed" /> },
      { label: "Nginx", icon: <SiNginx color="#009639" /> },
      { label: "CI/CD Pipelines", icon: <SiGithubactions color="#2088ff" /> },
      { label: "Terraform (Familiar)", icon: <SiTerraform color="#844fba" /> },
    ],
  },
  {
    title: "Tools & Concepts",
    items: [
      { label: "Git", icon: <SiGit color="#f05032" /> },
      { label: "GitHub", icon: <SiGithub color="#ffffff" /> },
      { label: "DSA", icon: <FaCode color="#0ea5e9" /> },
      { label: "System Design", icon: <FaSitemap color="#facc15" /> },
      { label: "SAP", icon: <SiSap color="#0f9ff8" /> },
      { label: "MS Excel", icon: <SiMicrosoftexcel color="#217346" /> },
      { label: "MS PowerPoint", icon: <SiMicrosoftpowerpoint color="#d24726" /> },
      { label: "MS Word", icon: <SiMicrosoftword color="#185abd" /> },
      { label: "Canva", icon: <SiCanva color="#00c4cc" /> },
    ],
  },
  {
    title: "AI Tooling",
    items: [
      { label: "GitHub Copilot", icon: <FaRobot color="#38bdf8" /> },
      { label: "ChatGPT", icon: <SiOpenai color="#74aa9c" /> },
      { label: "Claude", icon: <FaBrain color="#fbbf24" /> },
      { label: "Perplexity", icon: <FaSearch color="#a855f7" /> },
      { label: "LangChain", icon: <FaProjectDiagram color="#38bdf8" /> },
      { label: "LangGraph (Familiar)", icon: <FaProjectDiagram color="#22c55e" /> },
    ],
  },
];

const Skills = () => {
  return (
    <SkillsDiv id="skills">
      <p className="title">Tech Skills</p>
      <div className="mainContainer">
        <div className="skillsGrid">
          {skillSections.map((section) => (
            <div className="skillsSection" key={section.title}>
              <p className="subTitle">{section.title}</p>
              <div className="skillsListWrapper">
                <ul className="skillsList">
                  <Fade direction="up" duration={700} cascade triggerOnce>
                    {section.items.map((item) => (
                      <li key={item.label}>
                        <span>{item.icon}</span>
                        <p>{item.label}</p>
                      </li>
                    ))}
                  </Fade>
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SkillsDiv>
  );
};

export default Skills;
